import * as React from 'react';
import { Controller } from 'react-hook-form';
import { Textarea as FlowBiteTextarea } from 'flowbite-react';

import { InputProps } from './form.types';
import { Heading } from '@restworld/ui-ds-base';
import { cn } from '@restworld/utils-common';

interface TextAreaProps extends Omit<InputProps, 'onMouseDown' | 'twStyle'> {
  onMouseDown?: React.MouseEventHandler<HTMLTextAreaElement>;
  rows?: number;
  maxLength?: number;
  showMaxLength?: boolean;
  value?: string;
  twStyle?: string;
  minLength?: number;
}
export const TextArea: React.FunctionComponent<TextAreaProps> = (props) => {
  const {
    onChange,
    rules = {},
    id,
    required,
    control,
    type,
    rows = 4,
    maxLength,
    testId,
    twStyle,
    showMaxLength = true,
    isError,
    ...rest
  } = props;
  const [remainingChars, setRemainingChars] = React.useState<number>();
  const handleOnChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (!maxLength) return;
      const newRemainingChars = maxLength - event.target.value.length;
      setRemainingChars(newRemainingChars);
      return newRemainingChars;
    },
    [maxLength]
  );

  return control ? (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextAreaStyled
          {...field}
          {...rest}
          maxLength={maxLength}
          onChange={(evt) => {
            handleOnChange(evt);
            field.onChange(evt);
          }}
          data-cy={testId}
          twStyle={twStyle}
        />
      )}
    />
  ) : (
    <div className="relative">
      <TextAreaStyled
        id={id}
        rows={rows}
        {...rest}
        maxLength={maxLength}
        onChange={(evt) => {
          handleOnChange(evt);
          if (onChange) onChange(evt.target.value);
        }}
        data-cy={testId}
        twStyle={twStyle}
        isError={isError}
      />
      {maxLength && showMaxLength ? (
        <Heading as="span" size={6} weight="normal" color="muted" className="absolute right-4 bottom-2 text-xs">
          {`${remainingChars || maxLength}/${maxLength}`}
        </Heading>
      ) : null}
    </div>
  );
};
export default TextArea;
const TextAreaStyled = ({ isError, twStyle, className, ...props }: any) => (
  <FlowBiteTextarea
    className={cn(
      'bg-white',
      'border-primary-200 rounded-lg focus:!border-primary-300 focus:!ring-primary-300',
      (props.color === 'failure' || isError) && 'bg-red-50 border-red-500',
      twStyle,
      className
    )}
    {...props}
  />
);
